<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-file-invoice-dollar"></i></span>{{ "EvidenceCheck.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion (onOpen)="accordionTabOpen()">
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ "EvidenceCheck.Form.InvoiceNum" | translate }}</div>
              <div class="formgrid grid">
                <div class="col">
                  <input pInputText formControlName="guiIdStart" type="text" />
                </div>
                ~
                <div class="col">
                  <input pInputText formControlName="guiIdEnd" type="text" />
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ "EvidenceCheck.Form.GUINo" | translate }}</div>
              <div class="formgrid grid">
                <div class="col">
                  <input pInputText formControlName="guiNoStart" type="text" />
                </div>
                ~
                <div class="col">
                  <input pInputText formControlName="guiNoEnd" type="text" />
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 laas-calendar">
              <laas-calendar
                  #guiNoDt
                  [title]="'EvidenceCheck.Form.GUIDt'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event,'guiNoDt')"
                  [showCustomTime]="false"
                  dateFormat="yy-mm-dd">
              </laas-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ "EvidenceCheck.Form.VendorName" | translate }}</div>
              <div class="item">
                <p-dropdown
                  formControlName="vendorNo"
                  optionLabel="optionDesc"
                  optionValue="optionCode"
                  [options]="bookingVendorOptions"
                  [showClear]="true"
                  [filter]="true"
                  [disabled]="isForwarder"
                  filterBy="optionDesc"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ "EvidenceCheck.Form.OrgId" | translate }}</div>
              <div class="item">
                <p-dropdown
                  formControlName="billCorp"
                  [options]="billCorpList"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [filter]="true"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 laas-calendar">
              <laas-calendar
                  #createDt
                  [title]="'EvidenceCheck.Form.CreateDt'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event,'createDt')"
                  [showCustomTime]="false"
                  dateFormat="yy-mm-dd">
              </laas-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "EvidenceCheck.Form.Status" | translate }}</label>
              <div class="item">
                <p-dropdown
                  formControlName="status"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="statusOptions"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [filter]="true"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "EvidenceCheck.Form.InOutType" | translate }}</label>
              <div class="item">
                <p-dropdown
                  formControlName="inOutType"
                  [options]="inOutTypeOptions"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [filter]="true"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "EvidenceCheck.Form.SourceModel" | translate }}</label>
              <div class="item">
                <p-dropdown
                  formControlName="sourceModel"
                  [options]="expenseInvSourceOptions"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [filter]="true"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "EvidenceCheck.Form.ERPApKey" | translate }}</label>
              <div class="formgrid grid">
                <div class="col">
                  <input
                    pInputText
                    formControlName="erpApKeyStart"
                    type="text"
                  />
                </div>
                ~
                <div class="col">
                  <input pInputText formControlName="erpApKeyEnd" type="text" />
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "EvidenceCheck.Form.InvoiceId" | translate }}</label>
              <p-chips formControlName="invoiceId" separator=","></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ "EvidenceCheck.Form.FlowNo" | translate }}</label>
              <p-chips formControlName="flowNo" separator=","></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'EvidenceCheck.Form.Facility' | translate}}</label>
              <laas-facility-dropdown
                  formControlName="facilityList"
                  [isMultiple]="true"
                  [showClear]="false"
                  [showFilter]="true"
                  [defaultSelectFirst]="false"
                  [showToggleAll]="true"
              >
              </laas-facility-dropdown>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchClickBtn($event)"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Reset' | translate }}"
                (click)="resetClickBtn($event)"
                class="p-button-secondary ml-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <p-table
      #evidenceTable
      [columns]="selectedColumns"
      [value]="tableValue"
      [scrollable]="true"
      scrollHeight="500px"
      [reorderableColumns]="true"
      [resizableColumns]="true"
      [totalRecords]="this.pageInfo.totalRecords"
      (onPage)="this.tablePageChange($event)"
      (onSort)="this.tableSort($event)"
      (onRowSelect)="getDetailGovermentUniformInvoiceData()"
      [rowsPerPageOptions]="this.pageDropDownList"
      [showCurrentPageReport]="true"
      [paginator]="true"
      [rows]="100"
      [loading]="isHeaderLoading"
      [lazy]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      [(selection)]="selectedRow"
      selectionMode="single"
      class="edittable"
      dataKey="rowId"
      editMode="row"
      styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
      [(first)]="first"
    >
      <ng-template pTemplate="caption">
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="evidenceTable">
        </laas-table-column-toggle>
        <laas-permission-button
          permissionCode="EditGUICheck"
          type="button"
          label="{{ 'EvidenceCheck.Button.EditOrView' | translate }}"
          icon="fas fa-pen"
          [class]="'p-button-warning p-button-raised ml-2'"
          (onClick)="switchHeaderEditMode()"
          style="color: white"
        ></laas-permission-button>
        <laas-permission-button
          permissionCode="EditGUICheck"
          type="button"
          label="{{ 'Common.Button.Save' | translate }}"
          [disabled]="!editMode"
          icon="fas fa-save"
          (onClick)="saveBtnClick()"
          [class]="'p-button-raised ml-2'"
        ></laas-permission-button>
        <laas-permission-button
          permissionCode="EditGUICheck"
          type="button"
          label="{{ 'Common.Button.DownloadExcel' | translate }}"
          icon="fas fa-save"
          [class]="'p-button-raised ml-2'"
          [disabled]="editMode"
          (onClick)="govermentUniformInvoiceDownlondBtn(1)"
        ></laas-permission-button>
        <laas-permission-button
          permissionCode="EditGUICheck"
          type="button"
          label="{{ 'Common.Button.DownloadPdf' | translate }}"
          icon="fas fa-save"
          [class]="'p-button-raised ml-2'"
          [disabled]="editMode"
          (onClick)="govermentUniformInvoiceDownlondBtn(2)"
        ></laas-permission-button>
        <laas-permission-button
          permissionCode="BtnApproveGUI"
          label="{{ 'Common.Button.Approve' | translate }}"
          (onClick)="approveBtnClick()"
          [disabled]="isDisabledUpdate()"
          [class]="'ml-2'"
        ></laas-permission-button>
        <laas-permission-button
          permissionCode="BtnApproveGUI"
          label="{{ 'Common.Button.Return' | translate }}"
          (onClick)="rejectBtnClick()"
          [disabled]="isDisabledUpdate()"
          [class]="'ml-2'"
        ></laas-permission-button>
        <laas-permission-button
          permissionCode="BtnApproveGUI"
          label="{{ 'Common.Button.Resend' | translate }}"
          (onClick)="resendBtnClick()"
          [disabled]="isDisabledResendUpdate()"
          [class]="'ml-2'"
        ></laas-permission-button>
        <laas-permission-button
          permissionCode="BtnApproveGUI"
          label="{{ 'EvidenceCheck.Button.SubmitForApproval' | translate }}"
          (onClick)="erpFlowBtnClick()"
          [disabled]="isDisabledUpdate()"
          [class]="'ml-2'"
        ></laas-permission-button>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col style="width: 3vw" />
          <col *ngFor="let col of columns" style="width: 10.8vw" />
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>
            <p-checkbox
              [(ngModel)]="headerChecked"
              [binary]="true"
              (onChange)="selectAllOrUnSelectAll($event)"
            ></p-checkbox>
          </th>
          <th
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            *ngFor="let col of columns"
            pResizableColumn
            pReorderableColumn
          >
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr
          [pSelectableRow]="rowData"
          [pEditableRow]="rowData"
          (click)="onRowClick(rowData)"
          style="height:40px"
          [ngClass]="{
            'row-red': rowData.amountDifferenceColorFlag === 'R',
            'row-yellow': rowData.amountDifferenceColorFlag === 'Y'
          }"
        >
          <td>
            <p-checkbox
              [value]="rowData"
              [(ngModel)]="selectedRowsWithCheckBox"
              (onChange)="countTotalRow($event)"
            ></p-checkbox>
          </td>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'billCorp'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: billCorpList
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <p-cellEditor *ngSwitchCase="'guiDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-calendar
                    appendTo="body"
                    dateFormat="yy-mm-dd"
                    [showTime]="true"
                    [(ngModel)]="rowData[col.field]"
                  ></p-calendar>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'dueDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-calendar
                    appendTo="body"
                    dateFormat="yy-mm-dd"
                    [showTime]="true"
                    [(ngModel)]="rowData[col.field]"
                  ></p-calendar>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiAmount'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="4"
                    [(ngModel)]="rowData[col.field]"
                  ></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | number: "1.4-4"
                        | replaceNullWith: "0.0000"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor
                *ngSwitchCase="'shippingDescription'"
                class="p-fluid"
              >
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'description'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor
                *ngSwitchCase="'amountDifferenceDescription'"
                class="p-fluid"
              >
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiNo'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="flex-column-container">
                    <input
                      pInputText
                      type="text"
                      required
                      [(ngModel)]="rowData[col.field]"
                    />
                    <small *ngIf="rowData[col.field] && rowData[col.field].length > 30" class="p-invalid">
                      {{ 'EvidenceCheck.Message.GuiNoMaxLength' | translate }}
                    </small>
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="flex-column-container">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                    <small *ngIf="rowData[col.field] && rowData[col.field].length > 30" class="p-invalid">
                      {{ 'EvidenceCheck.Message.GuiNoMaxLength' | translate }}
                    </small>
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiCurrency'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="currencyOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.currencyOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchCase="'sourceModel'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: expenseInvSourceOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'carrierPaymentBy'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: carrierPaymentByOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'status'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: statusOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'paymentMethod'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: paymentMethodOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'termsId'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: termsIdOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <p-cellEditor *ngSwitchCase="'glDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'applyDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'createDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'updateDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <p-cellEditor *ngSwitchCase="'date'" class="p-fluid">
                    <ng-template pTemplate="input">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd HH:mm"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd HH:mm"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                  </p-cellEditor>
                  <ng-container *ngSwitchDefault class="p-fluid">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableColumns.length + 1">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div style="text-align: center" *ngIf="this.selectedRow">
      <h3>
        {{ "EvidenceCheck.Count" | translate }}{{ selectedRowCount }}．{{
          "EvidenceCheck.Total" | translate
        }}{{ selectedRowTotal | number: "1.4-4" }}
      </h3>
    </div>
    <p-table
      *ngIf="this.selectedRow"
      #detailEvidenceTable
      [columns]="selectedDetailColumns"
      [scrollable]="true"
      [value]="detailTableValue"
      scrollHeight="500px"
      [reorderableColumns]="true"
      [resizableColumns]="true"
      (onSort)="detailTableSort($event)"
      [totalRecords]="this.detailPageInfo.totalRecords"
      (onRowSelect)="getBillingOriginData()"
      (onPage)="this.detailTablePageChange($event)"
      [rowsPerPageOptions]="[100, 300, 500]"
      [showCurrentPageReport]="true"
      [paginator]="true"
      [rows]="100"
      [loading]="isDetailLoading"
      [lazy]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      [(selection)]="selectedDetailRows"
      selectionMode="single"
      class="edittable"
      dataKey="detailRowId"
      editMode="row"
      styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
    >
      <ng-template pTemplate="caption">
        <laas-table-column-toggle
          [optionsColumn]="detailColumns"
          [dataTable]="detailEvidenceTable">
        </laas-table-column-toggle>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col style="width: 3vw" />
          <col *ngFor="let col of columns" style="width: 10.8vw" />
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>
            <p-checkbox
              [(ngModel)]="detailChecked"
              [binary]="true"
              (onChange)="selectDetailAllOrUnSelectDetailAll($event)"
            ></p-checkbox>
          </th>
          <th
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            *ngFor="let col of columns"
            pResizableColumn
            pReorderableColumn
          >
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr
          [pSelectableRow]="rowData"
          [pEditableRow]="rowData"
          (click)="detailOnRowClick(rowData)"
        >
          <td>
            <p-checkbox
              [value]="rowData"
              [(ngModel)]="selectedDetailRowsWithCheckBox"
            ></p-checkbox>
          </td>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <p-cellEditor *ngSwitchCase="'invoiceType'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="invoiceTypeOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.invoiceTypeOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'vatCode'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-inputNumber
                    mode="decimal"
                    [(ngModel)]="rowData[col.field]"
                  ></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'salerName'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'accountCode'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="accountCodeBigOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.accountCodeBigOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchCase="'guiCurrency'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: currencyOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'linePayCurrency'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: currencyOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'termsId'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: termsIdOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <p-cellEditor *ngSwitchCase="'salerNo'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'amount'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="4"
                    [(ngModel)]="rowData[col.field]"
                  ></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | number: "1.4-4"
                        | replaceNullWith: "0.0000"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiTaxAmount'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="4"
                    [(ngModel)]="rowData[col.field]"
                  ></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | number: "1.4-4"
                        | replaceNullWith: "0.0000"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'taxCode'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="taxCodeOptions"
                    (onChange)="changeTaxOptions()"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | taxOptionsMapping: this.taxCodeOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor
                *ngSwitchCase="'guiAmountWithoutTax'"
                class="p-fluid"
              >
                <ng-template pTemplate="input">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="4"
                    [(ngModel)]="rowData[col.field]"
                  ></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | number: "1.4-4"
                        | replaceNullWith: "0.0000"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiAmount'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="4"
                    [(ngModel)]="rowData[col.field]"
                  ></p-inputNumber>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | number: "1.4-4"
                        | replaceNullWith: "0.0000"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'applyAmount'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    <p-inputNumber
                      mode="decimal"
                      [minFractionDigits]="5"
                      [maxFractionDigits]="5"
                      [maxlength]="15"
                    ></p-inputNumber>
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "0.0000" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'expressBill'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor
                *ngSwitchCase="'importDeclarationNo'"
                class="p-fluid"
              >
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'description'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'cutCode'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'lineDescription'" class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <p-cellEditor *ngSwitchCase="'date'" class="p-fluid">
                    <ng-template pTemplate="input">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                  </p-cellEditor>
                  <ng-container *ngSwitchDefault class="p-fluid">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <p-cellEditor *ngSwitchCase="'createDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'updateDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchCase="'orgId'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: billCorpList
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <p-cellEditor *ngSwitchCase="'formatType'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="formatTypeOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.formatTypeOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="detailColumns.length + 1">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-table
      *ngIf="this.selectedRow"
      #evidenceTable
      [columns]="selectedBillColumns"
      [scrollable]="true"
      [value]="billTableValue"
      scrollHeight="500px"
      [reorderableColumns]="true"
      [resizableColumns]="true"
      (onSort)="billTableSort($event)"
      [totalRecords]="this.billPageInfo.totalRecords"
      (onPage)="this.billTablePageChange($event)"
      [rowsPerPageOptions]="[100, 300, 500]"
      [showCurrentPageReport]="true"
      [paginator]="true"
      [rows]="100"
      [loading]="isBillLoading"
      [lazy]="true"
      [(selection)]="selectedBillRows"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      selectionMode="single"
      class="edittable"
      dataKey="billRowId"
      editMode="row"
      styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
    >
      <ng-template pTemplate="caption">
        <laas-table-column-toggle
          [optionsColumn]="billColumns"
          [dataTable]="evidenceTable">
        </laas-table-column-toggle>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" style="width: 10.8vw" />
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            *ngFor="let col of columns"
            pResizableColumn
            pReorderableColumn
          >
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr
          [pSelectableRow]="rowData"
          [pEditableRow]="rowData"
          [ngClass]="{
            'row-red': rowData.diffRatio < 0
          }"
        >
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <p-cellEditor *ngSwitchCase="'opexOrgId'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="billCorpList"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | opexOrgIdOptionsMapping: billCorpList
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchCase="'paymentMethod'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: paymentMethodOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <p-cellEditor *ngSwitchCase="'billCorp'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="billCorpList"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.billCorpList
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'billingStatus'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="statusOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.statusOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'accountCode'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="accountCodeDetailOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.accountCodeDetailOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'inOutType'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="inOutTypeOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.inOutTypeOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'linePayCurrency'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="currencyOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.currencyOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'preCurrencyCode'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="currencyOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.currencyOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiCurrency'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="currencyOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.currencyOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'billType'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="billTypeOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.billTypeOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchCase="'termsId'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping: termsIdOptions
                      | replaceNullWith: "-"
                  }}
                </div>
              </ng-container>
              <p-cellEditor *ngSwitchCase="'invoiceType'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="invoiceTypeOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.invoiceTypeOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'carrierPaymentBy'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="carrierPaymentByOptions"
                    appendTo="body"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: this.carrierPaymentByOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'guiDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'applyDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'dueDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'createDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'updateDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date
                          : "yyyy-MM-dd HH:mm"
                          : this.laasSetting.facilityTimeZone
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-container *ngSwitchDefault>
                <ng-container [ngSwitch]="col.dataType">
                  <p-cellEditor *ngSwitchCase="'date'" class="p-fluid">
                    <ng-template pTemplate="input">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith: "-"
                        }}
                      </div>
                    </ng-template>
                  </p-cellEditor>
                  <ng-container *ngSwitchDefault class="p-fluid">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableColumns.length + 1">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>

  </p-card>
</div>

<p-confirmDialog [appendTo]="'body'" [key]="'headerConfirm'"></p-confirmDialog>

<p-confirmDialog [appendTo]="'body'" [key]="'detailConfirm'"></p-confirmDialog>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
